import api from '@pray/shared/utils/api';

export type SystemCheckSocialClip = {
  task_public_id: string;
  content_public_id: string;
  content_title: string;
  artist_name: string;
  artist_public_id: string;
  status: string;
  task_triggered_at: string;
  updated_at: string;
  opus_stage: string | null;
  opus_project_id: string | null;
};

export type SystemCheckSocialClipsResponse = {
  data: SystemCheckSocialClip[];
  pagination: {
    next_cursor: string | null;
    has_more: boolean;
    total_count: number;
  };
};

export type GetSystemCheckSocialClipsParams = {
  cursor?: string | null;
  limit?: number;
  status?: string;
};

export async function getSystemCheckSocialClips({
  cursor = null,
  limit = 50,
  status,
}: GetSystemCheckSocialClipsParams = {}): Promise<SystemCheckSocialClipsResponse> {
  const params: Record<string, string | number> = { limit };

  if (cursor) params.cursor = cursor;
  if (status) params.status = status;

  const url = '/web/studio/system-check/social-clips';
  const response = await api.executeGetRequest<{ data: SystemCheckSocialClipsResponse }>(url, params);

  return response.data.data;
}
